import axios from 'axios';
import { REST_HOSTNAME } from '../Config';
import { ScoreGrade } from '../Score';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export interface IUserDialogPromptReportRow {
    user_id: number
    user_first_name: string
    user_last_name: string
    user_email: string
    course_id: number
    course_name: string
    lesson_id: number
    lesson_name: string
    dialog_id: number
    dialog_title: string
    dialog_prompt_count: number
    total_dialog_prompt_count: number
    user_dialog_prompt_datetime: string
}

export type ISentenceScoreReportRow = {
    sentence_score_id: number
    sentence_id: number
    user_id: number
    user_first_name: string
    user_last_name: string
    user_email: string
    sentence_score_datetime: string
    text: string
    pinyin_list_transcript: string[]
    pinyin_list_spoken: string[]
    score: number[]
    score_grade: ScoreGrade[]
    score_mean: number
    is_silence: boolean[]
};

export type ICommentReportRow = {
    comment_id: number
    class_name: string
    user_id: number
    user_first_name: string
    user_last_name: string
    user_email: string
    user_hsk_level: string
    good_comment: string
    bad_comment: string
    bug_report: string
    bug_category: string | null
    sentence_score_id: number | null
    sentence_audio_id: number | null
    sentence_id: number | null
    text_to_speech_speaker_id: string | null
    is_slow_audio: boolean | null
    dialog_prompt_id: number | null
    audio_text: string | null
    audio_role: string | null
    created_at: number
};

export const ReportApi = {
    getUserDialogPrompt: function () {
        return axiosInstance.request<IUserDialogPromptReportRow[]>({
            method: "GET",
            url: `/user_dialog_prompt_report`
        });
    },
    getSentenceScore: function () {
        return axiosInstance.request<ISentenceScoreReportRow[]>({
            method: "GET",
            url: `/sentence_score_report`
        });
    },
    getComment: function () {
        return axiosInstance.request<ICommentReportRow[]>({
            method: "GET",
            url: `/comment_report`
        });
    },

}
